import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  Typography
} from '@mui/material';

type PasswordSettingsPropsType = {
  setNewPassword: (password: string) => void
  span: string
}

export const PasswordSettings = React.memo((props: PasswordSettingsPropsType) => {
  const [err, setError] = useState(false)
  const [values, setValues] = useState({
    password: '',
    confirm: ''
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  }

  const updatePassword = () => {
    if (values.password !== values.confirm) {
      setError(true)
    } else {
      setError(false)
      props.setNewPassword(values.confirm)
      setValues({ password: '', confirm: '' })
    }
  }

  return (
    <form >
      <Card>
        {props.span === 'inline' ?
          <CardContent style={{ width: '400px', textAlign: 'center' }}>
            <Typography style={{ marginRight: '10px', color: '#24bced', display: `${props.span}` }} > New password is saved!</Typography>
          </CardContent>
          : <>
            <CardHeader
              title="Change password"
            />
            <Divider />
            <CardContent>
              <TextField
                fullWidth
                label="new password"
                margin="normal"
                name="password"
                onChange={handleChange}
                type="password"
                value={values.password}
                variant="outlined"
              />
              <TextField
                fullWidth
                error={err}
                label="comfirm password"
                margin="normal"
                name="confirm"
                onChange={handleChange}
                type="password"
                value={values.confirm}
                variant="outlined"
              />
            </CardContent>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2
              }}
            >

              <Button
                color="info"
                variant="contained"
                onClick={updatePassword}
                disabled={values.password === '' && values.confirm == ''}
              >
                Save
              </Button>
            </Box>
          </>}
      </Card>
    </form>
  );
});
